import { PseudoHeader } from "@/react/features/globalization/cellRenderers";
import React from "react";
import styled from "styled-components";

const StyledPseudoHeader = styled(PseudoHeader)`
  text-decoration: underline;
  text-underline-offset: 2px;
`;

export const HorizontalHeader = (props) => {
  return <StyledPseudoHeader>{props.children}</StyledPseudoHeader>;
};
